/* eslint-disable react/prop-types */
import React from 'react';

import { StyledGeneralMessage } from './styles';
import iconSuccess from '../../../assets/img/icon-success.svg';
import iconError from '../../../assets/img/icon-error.svg';
import iconWarning from '../../../assets/img/icon-warning.svg';
import iconInfo from '../../../assets/img/icon-info.svg';

const iconsByName = {
  error: iconError,
  info: iconInfo,
  success: iconSuccess,
  warning: iconWarning,
};

const GeneralMessage = (props) => {
  const { type, iconVisibility, alignIcon, children, size, bgOpacity } = props;
  let padding = '';
  if (size === 'small') padding = 'padding-x-12 padding-y-14';
  if (size === 'medium') padding = 'padding-x-32 padding-y-24';

  return (
    <StyledGeneralMessage
      className={`${padding || 'p-3'} d-flex ${
        alignIcon === 'left' ? 'flex-row-reverse' : ''
      } bg-${type}-${bgOpacity ? 'opacity' : '05'} rounded`}
    >
      {children}
      {iconVisibility && (
        <div>
          <img src={iconsByName[type]} width="18" alt="icon" />
        </div>
      )}
    </StyledGeneralMessage>
  );
};

export default GeneralMessage;
